import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export interface GetShipmentSpotBidAddressRequestParams {
  Shipmentkey: number;
  CustomerKey: number;
  RoutingType: number;
}

export const getShipmentSpotBidAddressAPI = (params: GetShipmentSpotBidAddressRequestParams) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetSpotBidAddress`,
    method: 'get',
    params: params,
  });
};

export type ShipmentSpotBidAddressResponse = {
  carrierName: string;
  tenderEmailAddress: string;
  carrierKey: number;
  distributionName: string;
  checked: 0 | 1;
}[];

export const fetchShipmentSpotBidAddress = async (
  params: GetShipmentSpotBidAddressRequestParams,
): Promise<ShipmentSpotBidAddressResponse> => {
  const response: AxiosResponse<ShipmentSpotBidAddressResponse> = await getShipmentSpotBidAddressAPI(params);
  return response.data;
};
